import { getLocalizedSearchPath } from "@/config"
import { QUERY_PARAM } from "@/mapping/url/constants"

/**
 * Redirects to the search page with the given query.
 * Preserves the current locale prefix (e.g., /en-ca/, /fr-ca/) in the URL.
 * @param query - The search query to redirect with
 */
export function searchRedirect(query: string) {
  const url = new URL(getLocalizedSearchPath(), window.location.origin)
  url.searchParams.set(QUERY_PARAM, query)

  window.location.href = url.href
}
